module.exports = __webpack_public_path__ + "MinionPro-Regular.bd5e184a36669c70bf3c.woff";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/MinionPro-Regular/MinionPro-Regular.woff
// module id = ../../../../../src/assets/fonts/MinionPro-Regular/MinionPro-Regular.woff
// module chunks = styles